module.exports = __webpack_public_path__ + "static/media/mic.0beb18b6.svg";